import { ICatalogue, ICatalogueCustomization } from "../../apis/useGetCatalogueData/types";
import { uniqueArray } from "../../common/helpers/general";
import { PDP_INPUT_STATUS } from "./constants";

export const getSelectedItem = (
	items: ICatalogue[],
	selected: string[],
	external_id: string,
	setitem?: { quantity: number }
) =>
	selected
		.map((select) => {
			const selectedsetitem = items.find(({ id }) => id === select);

			if (!selectedsetitem) {
				return null;
			}

			return {
				title: selectedsetitem.title,
				title_cn: selectedsetitem.title_cn,
				external_id,
				bcrs: selectedsetitem.bcrs,
				food_supplier_menu_item_id: selectedsetitem.id,
				quantity: setitem?.quantity ?? 1,
			};
		})
		.filter((item) => item !== null);

const getCountOfOptions = (opts: string[], optid: string): number => {
	return opts.filter((id) => id === optid).length;
};

export const getSelectedCustomization = (
	customization: ICatalogueCustomization,
	selected: string[]
) => {
	const unique_selections = uniqueArray(selected);
	const selected_options = unique_selections
		.map((select) => {
			return customization.food_supplier_customization_options?.find(({ id }) => id === select);
		})
		.filter((opt) => opt !== undefined);

	const food_supplier_customization_options = selected_options.map((opt) => ({
		id: opt.id,
		title: opt.title,
		title_cn: opt.title_cn,
		brand_customization_option_id: opt.brand_customization_option_id,
		food_supplier_customization_id: opt.food_supplier_customization_id,
		quantity: getCountOfOptions(selected, opt.id),
		price_diff: opt.price,
	}));

	return {
		id: customization.id,
		title: customization.title,
		title_cn: customization.title_cn,
		brand_customization_id: customization.brand_customization_id,
		quantity: customization.quantity ?? 1,
		food_supplier_customization_options,
	};
};

export const checkAllPDPInputsAdded = (data: ICatalogue, item: ICatalogue): boolean => {
	const { food_supplier_set_items } = item;

	const itemsToIterate = food_supplier_set_items ?? [];

	if (itemsToIterate.length > 0) {
		if (!data.food_supplier_set_items?.filter((i) => i.external_id)?.length) {
			return false;
		}
	}

	if (item.food_supplier_customizations?.length) {
		for (const customization of item.food_supplier_customizations) {
			const foundCustomization = data.food_supplier_customizations?.find(
				(c) => c.id === customization.id
			);

			if (!foundCustomization) {
				return false;
			}
		}
	}

	return true;
};

export const hasInvalidInput = () => {
	const hasInvalid = document.querySelectorAll(`[data-inputstatus='${PDP_INPUT_STATUS.BAD}']`);

	return hasInvalid.length > 0;
};
